// Non-case-study project pages. Each entry feeds the reusable
// `ProjectGallery` template — a quiet, image-led visual study of the
// residence (no process text, no design notes). To add another
// non-case-study project, append an entry with the same shape; no
// other code changes are required.

const PROJECT_GALLERIES = {
  "in-the-warm-after": {
    slug: "in-the-warm-after",
    name: "In The Warm After;",
    type: "Residence",
    location: "Binnypet, Bengaluru",
    description:
      "This apartment in the heart of Bengaluru was crafted for a multigenerational family. Envisioned as a modern yet regal home, it reflects cultural heritage, regional ways of living, and the quiet warmth of shared memory.",
    imageBase: "/projects/in-the-warm-after/",
    images: [
      "01-foyer.jpg",
      "02-foyer.jpg",
      "03-foyer.jpg",
      "04-living-room.jpg",
      "05-living-room.jpg",
      "06-living-room.jpg",
      "07-living-room.jpg",
      "08-living-room.jpg",
      "09-living-room.jpg",
      "10-living-room.jpg",
      "11-living-room.jpg",
      "12-living-room.jpg",
      "13-living-room.jpg",
      "14-dining-room.jpg",
      "15-dining-room.jpg",
      "16-dining-room.jpg",
      "17-kitchen.jpg",
      "18-master-bedroom.jpg",
      "19-master-bedroom.jpg",
      "20-master-bedroom.jpg",
      "21-master-bedroom.jpg",
      "22-master-bathroom.jpg",
      "23-parents-room.jpg",
      "25-parents-bathroom.jpg",
      "26-kids-room.jpg",
      "27-kids-room.jpg",
      "28-kids-room.jpg",
      "29-kids-bathroom.jpg",
    ],
    prev: {
      slug: "ripples",
      name: "Ripples",
      location: "Jayanagar, Bengaluru",
    },
    next: {
      slug: "tie-and-untie",
      name: "Tie and Untie",
      location: "Yemlur, Bengaluru",
    },
  },
  "tie-and-untie": {
    slug: "tie-and-untie",
    name: "Tie and Untie",
    type: "Residence",
    location: "Yemlur, Bengaluru",
    description:
      "A choreography of earthy materiality, generous daylight, and contemporary identity, shaped into an endearing dwelling in Bengaluru\u2019s embrace.",
    imageBase: "/projects/tie-and-untie/",
    images: [
      "01-foyer.jpg",
      "02-living-room.jpg",
      "03-living-room.jpg",
      "04-living-room.jpg",
      "05-living-room.jpg",
      "06-living-room.jpg",
      "07-informal-living-bar-unit.jpg",
      "08-informal-living-bar-unit.jpg",
      "09-informal-living-bar-unit.jpg",
      "10-informal-living-bar-unit.jpg",
      "11-informal-living-bar-unit.jpg",
      "12-bar-unit.jpg",
      "13-dining-and-crockery.jpg",
      "14-dining-and-crockery.jpg",
      "15-kitchen.jpg",
      "16-kitchen.jpg",
      "17-master-bedroom.jpg",
      "18-master-bedroom.jpg",
      "19-master-bedroom.jpg",
      "20-master-bedroom.jpg",
      "21-master-bedroom.jpg",
      "22-master-bathroom.jpg",
      "23-master-bath.jpg",
      "24-guest-bedroom.jpg",
      "25-guest-bedroom.jpg",
      "28-powder-room.jpg",
    ],
    prev: {
      slug: "in-the-warm-after",
      name: "In The Warm After;",
      location: "Binnypet, Bengaluru",
    },
    next: {
      slug: "windows-to-art",
      name: "Windows to Art",
      location: "Basavanagudi, Bengaluru",
    },
  },
  "windows-to-art": {
    slug: "windows-to-art",
    name: "Windows to Art",
    type: "Residence",
    location: "Basavanagudi, Bengaluru",
    description:
      "Nestled within the vibrant streets of Basavanagudi is a cherished ancestral home, nearly a century old. We were invited to craft the interiors of its extended wing, transforming it into a sanctuary of distinct yet connected spaces.",
    imageBase: "/projects/windows-to-art/",
    images: [
      "1a.jpg",
      "1b.jpg",
      "1c.jpg",
      "1d.jpg",
      "1e.jpg",
      "1f.jpg",
      "1l.jpg",
      "2a.jpg",
      "2b.jpg",
      "2c.jpg",
      "2d.jpg",
      "2e.jpg",
      "2f.jpg",
      "2g.jpg",
      "2h.jpg",
      "2i.jpg",
      "3a.jpg",
      "3b.jpg",
      "3c.jpg",
      "3d.jpg",
      "3e.jpg",
      "3f.jpg",
      "3g.jpg",
      "3h.jpg",
      "3i.jpg",
      "3j.jpg",
      "3k.jpg",
    ],
    prev: {
      slug: "tie-and-untie",
      name: "Tie and Untie",
      location: "Yemlur, Bengaluru",
    },
    next: {
      slug: "chickoo-mane",
      name: "Chikoo Mane",
      location: "JP Nagar, Bengaluru",
    },
  },
  gurukul: {
    slug: "gurukul",
    name: "The Thread of Tradition",
    credibility: "Sri Kumaran Children\u2019s Home Educational Council",
    type: "Institution",
    location: "Tata Silk Farm, Bengaluru",
    description:
      "For this educational institution in Bengaluru, we shaped two connected spaces: a welcoming office for the new Principal and an adjacent Visitors\u2019 Lounge imagined as more than a waiting area. Together, they create a setting for leadership, memory, and welcome.",
    imageBase: "/projects/gurukul/",
    images: [
      "01-gurukul.jpg",
      "02-gurukul.jpg",
      "03-gurukul.jpg",
      "04-gurukul.jpg",
      "05-gurukul.jpg",
      "06-gurukul.jpg",
      "07-gurukul.jpg",
      "08-gurukul.jpg",
      "09-gurukul.jpg",
      "10-gurukul.jpg",
      "11-gurukul.jpg",
      "12-gurukul.jpg",
    ],
    prev: {
      slug: "chickoo-mane",
      name: "Chikoo Mane",
      location: "JP Nagar, Bengaluru",
    },
    next: {
      slug: "ripples",
      name: "Ripples",
      location: "Jayanagar, Bengaluru",
    },
  },
  "chickoo-mane": {
    slug: "chickoo-mane",
    name: "Chikoo Mane",
    type: "Residence",
    location: "JP Nagar, Bengaluru",
    description:
      "Sculpted for a young family of three, this home is set within the verdant embrace of chikoo trees. Built around an open-plan way of living, the design allows the family to stay rooted in South Indian traditions while forming a quiet connection with contemporary architecture.",
    imageBase: "/projects/chickoo-mane/",
    images: [
      "01-chickoo-mane.jpg",
      "02-chickoo-mane.jpg",
      "03-chickoo-mane.jpg",
      "04-chickoo-mane.jpg",
      "05-chickoo-mane.jpg",
      "06-chickoo-mane.jpg",
      "07-chickoo-mane.jpg",
      "08-chickoo-mane.jpg",
      "09-chickoo-mane.jpg",
      "10-chickoo-mane.jpg",
      "11-chickoo-mane.jpg",
      "12-chickoo-mane.jpg",
      "13-chickoo-mane.jpg",
      "14-chickoo-mane.jpg",
      "15-chickoo-mane.jpg",
    ],
    prev: {
      slug: "windows-to-art",
      name: "Windows to Art",
      location: "Basavanagudi, Bengaluru",
    },
    next: {
      slug: "gurukul",
      name: "The Thread of Tradition",
      location: "Tata Silk Farm, Bengaluru",
    },
  },
};

export const getProjectGallery = (slug) => PROJECT_GALLERIES[slug] || null;
